<template>
    <div>
      <div v-if="isShow">
         <div v-if="listType==='baseCourse'">
          <div class="t_header">{{selectItem.courseName}}</div>
          <Select type="CourseTable" @change="handleSearch" @export="handleExport"></Select>
          <CourseTable
              :tableData="tableData"
              type="baseCourse"
              @toLink="handleLink"
          ></CourseTable>
          <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
        </div>
        <div v-if="listType==='resourcesCourse'">
          <div class="t_header">{{selectItem.courseName}} {{selectItem.courseCode}} 
            ({{dictList.find(v=>v.value===selectItem.examinationType)?dictList.find(v=>v.value===selectItem.examinationType).label:''}}/
            {{videoList.find(v=>v.id===Number(selectItem.videoType))?videoList.find(v=>v.id===Number(selectItem.videoType)).videoTypeTitle:''}}/
            {{courseAttributeList.find(v=>v.id===selectItem.courseAttribute)?courseAttributeList.find(v=>v.id===selectItem.courseAttribute).label:''}})</div>
          <Select type="resourcesCourse" @change="handleSearch" @export="handleExport"></Select>
          <CourseTable
              :tableData="tableData"
              type="resourcesCourse"
          ></CourseTable>
          <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
        </div>
      </div>
      <dibbleItemList v-else :listType="listType" :courseItem="courseItem"></dibbleItemList>
    </div>
</template>

<script>;
import CourseTable from "./CourseTable.vue";
import pagination from "../ClassStatistics/Pagination/index.vue";
import dibbleItemList from "./dibbleItemList.vue";
import Select from "./select.vue";
import {
    getBatchList,
    getCourseList,
    getRatioByBatchId
} from "@/api/TeachingStatistics";
import {getVideoType,getBaseDictType} from '@/api/TeacherClassroomManagement/MyClassroomTution'
export default {
    props:{
      listType: {type:String,default:''},
      selectItem:{type:Object,default:()=>{return{}}}
    },
    components: {
      CourseTable,
      pagination,
      dibbleItemList,
      Select
    },
    data() {
      return {
        activeName: "major",
        tableData: [],
        totalCount: {},
        total: 0,
        queryParams:{pageSize:10,page:1},
        videoList:[], // 考试类别
        dictList:[
          {label: "笔试",value:'1'},
          {label: "实践考核",value:'2'}
        ], // 考试方式
        courseAttributeList:[
          {id:'1',label:'考核'},
          {id:'2',label:'培训'},
        ], // 课程属性
        forms:{
          
        },
        average:[], // 成绩占比
        isShow: true,
        courseItem:''
      };
    },
    computed: {
      url() {
        let url = window.location.protocol + "//" + window.location.host;
        if (window.location.host == "localhost:5001"  ) {
          url = "http://gz.hnjk.net";
        }
        return url;
      },
    },
    methods: {
        // 标签页切换
        async handleClick() {
            if (this.listType === "baseCourse") {
              const res = await getCourseList({courseId:this.selectItem.courseId});
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            }
            if (this.listType === "resourcesCourse") {
              const res = await getBatchList({courseId:this.selectItem.courseId});
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            }
        },
        /** 搜索/重置事件 */
        async handleSearch(params){
          this.forms = params;
          if (this.listType === "baseCourse") {
            const res = await getCourseList({...params,courseId:this.selectItem.courseId});
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
          if (this.listType === "resourcesCourse") {
            const res = await getBatchList({...params,courseId:this.selectItem.courseId});
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
        },
        /** 获取考试类别 */
        async getVideoTypes(){
          let {data} = await getVideoType()
          this.videoList = data.data;
        },
        /** 获取考试方式 */
        async getBaseDictTypes(){
          let {data} = await getBaseDictType();
          this.dictList = data.data;
        },
        /** 导出结果 */
        handleExport(form){
          this.forms = form;
          if(this.listType==='resourcesCourse'){
            window.open(
              `${this.url}/zkfz/statistics/batchListExport?courseId=${this.selectItem.courseId}&courseGroupCode=${form.courseGroupCode}&degreeName=${form.degreeName}&eduLevel=${form.eduLevel}&enrollMajorCode=${form.enrollMajorCode}&mainSchoolCode=${form.mainSchoolCode}&mainSchoolName=${form.mainSchoolName}&majorCode=${form.majorCode}&majorName=${form.majorName}&schoolId=${this.forms.schoolId!==undefined?this.forms.schoolId:""}&timeRange=${this.forms.timeRange!==undefined?this.forms.timeRange:""}&startTime=${this.forms.startTime!==undefined?this.forms.startTime:""}&endTime=${this.forms.endTime!==undefined?this.forms.endTime:""}`
            );
          }else if(this.listType === 'baseCourse'){
            window.open(
              `${this.url}/zkfz/statistics/courseListExport?courseId=${this.selectItem.courseId}&courseName=${form.courseName}&courseCode=${form.courseCode}&examinationType=${form.examinationType}&schoolName=${form.schoolName}&teacherName=${form.teacherName}&courseAttribute=${form.courseAttribute}&examCategory=${form.examCategory}&schoolId=${this.forms.schoolId!==undefined?this.forms.schoolId:""}&timeRange=${this.forms.timeRange!==undefined?this.forms.timeRange:""}&startTime=${this.forms.startTime!==undefined?this.forms.startTime:""}&endTime=${this.forms.endTime!==undefined?this.forms.endTime:""}`
            );
          }
        },
        /** 进入课程名称详情 */
        handleLink(item){
          console.log('item',item)
          this.courseItem = item;
          this.isShow = false;
        }
    },
    mounted() {
      this.handleClick();
      this.getVideoTypes();
      // this.getBaseDictTypes();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    background-color: #64b0ff;
    span {
        color: #fff;
        .num {
            font-size: 24px;
            font-weight: 700;
            color: red;
        }
        .num:hover {
            color: #409eff;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #d7d7d7;
    border: 0;
    span {
        color: #000;
        .num {
            color: red;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    height: 70px;
    padding-top: 30px;
    margin-top: 3px;
}
.t_header{
  background-color: #64b0ff;
  height: 58px;
  // margin: 0 auto;
  text-align: center;
  line-height: 58px;
  color: white;
  margin-top: 2px;
}
</style>